import React from 'react';
import AccurityIconButton from '../../../buttons/components/AccurityIconButton';
var DiagramControlsBar = function (_a) {
    var controls = _a.controls, onClose = _a.onClose;
    return (React.createElement("div", { className: "interactiveDiagram__controlsBar" },
        controls,
        React.createElement(AccurityIconButton, { iconName: "mui:Close", size: "small", onClick: onClose, className: "diagramTopBar__closeButton" })));
};
export default DiagramControlsBar;
//# sourceMappingURL=DiagramControlsBar.js.map